var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-tag',{class:_vm.$style.avatarBox},[_c('img',{class:_vm.$style.imageBox,attrs:{"src":_vm.src,"alt":""},on:{"error":_vm.handleError}}),_c('span',{class:_vm.$style.label},[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }